import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { hero, stats } from "../mock";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-28 pb-10 lg:pt-32">
      {/* ambient glows */}
      <div className="absolute -top-40 -right-40 w-[38rem] h-[38rem] rounded-full bg-[var(--crimson)]/[0.06] blur-[130px] pointer-events-none" />
      <div className="absolute top-40 -left-52 w-[34rem] h-[34rem] rounded-full bg-[var(--gold)]/[0.04] blur-[130px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          {/* text */}
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full border border-[var(--line)] px-4 py-1.5 mb-8">
              <Sparkles size={13} className="text-[var(--gold)]" />
              <span className="eyebrow text-[0.62rem]">{hero.eyebrow}</span>
            </div>

            <h1 className="font-serif-display font-bold leading-[0.98] tracking-[-0.03em] text-4xl sm:text-5xl lg:text-[3.4rem]">
              <span className="block text-[var(--ivory)]">{hero.headline}</span>
              <span className="block italic text-gradient-gold mt-1">{hero.headlineAccent}</span>
            </h1>

            <p className="mt-8 text-[var(--muted)] leading-relaxed max-w-lg">
              {hero.desc}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a href="#contact" className="btn-gold px-7 py-3.5 rounded-full inline-flex items-center gap-2 group">
                Book a Strategy Call
                <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a href="#solutions" className="btn-ghost px-7 py-3.5 rounded-full inline-flex items-center gap-2">
                Explore Solutions
              </a>
            </div>
          </div>

          {/* portrait */}
          <div className="lg:col-span-5 relative">
            <div className="relative flex justify-center">
              <div className="absolute inset-x-6 bottom-0 top-10 rounded-[2rem] bg-gradient-to-b from-[var(--crimson)]/20 to-transparent blur-2xl" />
              <div className="absolute bottom-6 w-64 h-64 rounded-full border border-[var(--gold)]/30" />
              <img
                src={hero.photo}
                alt="Nitin Gupta"
                className="relative z-10 w-[22rem] lg:w-full max-w-md drop-shadow-2xl"
              />
            </div>
          </div>
        </div>

        {/* stats */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-px bg-[var(--line)] rounded-2xl overflow-hidden border border-[var(--line)]">
          {stats.map((s) => (
            <div key={s.label} className="bg-[var(--surface)] px-6 py-7 text-center">
              <div className="font-serif-display text-4xl sm:text-5xl font-semibold text-gradient-gold">
                {s.value}
              </div>
              <div className="mt-2 text-xs sm:text-sm text-[var(--muted)]">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
